import { Col, Container, Row } from "react-bootstrap";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { stripTags } from "@/functions/stripTags";
import React from "react";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { Details } from "@/ui/Details";

export const CollapsibleTextImage = ({ className, tag, title, content, image, youtubeVideoURL, moreText }) => {
  return (
    <div className={clsx(className, classes.content)}>
      <Container className={clsx("px-2 px-md-3", { "pt-5 pb-2": !!tag })}>
        {tag && <h1 className={classes.content__tag}>{tag}</h1>}
        <Row className="position-relative pt-md-5">
          <Col xs={12} lg={6} className="px-3">
            <div className="mt-4 me-3">
              <h3 className="h4 title-bar-primary mb-4">{title}</h3>
              <div dangerouslySetInnerHTML={{ __html: content }} />
              {moreText && (
                <Details>
                  <div dangerouslySetInnerHTML={{ __html: moreText }} />
                </Details>
              )}
            </div>
          </Col>
          <Col xs={12} lg={6}>
            {youtubeVideoURL ? (
              <YoutubeVideoModal video_embed_url={stripTags(youtubeVideoURL).trim()}>
                <div className="ratio ratio-4x3 mt-4">
                  <img
                    src={image?.url}
                    alt={image?.alt}
                    style={{ objectFit: "cover", objectPosition: "center right" }}
                    className={"object-fit-cover"}
                  />
                </div>
              </YoutubeVideoModal>
            ) : (
              <div className="ratio ratio-4x3 mt-4">
                <img
                  src={image?.url}
                  alt={image?.alt}
                  style={{ objectFit: "cover", objectPosition: "center right" }}
                  className={"object-fit-cover"}
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CollapsibleTextImage;
